// MapCard.js

import * as React from 'react';
import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import MapView from './MapView';
import { authFetch } from '../authFetch';

export default function MapCard() {
  const [updateDate, setUpdateDate] = useState('');
  // 1. Add state to hold the flood GeoJSON data
  const [floodData, setFloodData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch data from endpoint
    authFetch('/api/flood-data/')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(apiResponse => {
        // Set the date like before
        setUpdateDate(apiResponse.satellite_data_date);
        // 2. ALSO, save the actual map data into our new state variable
        setFloodData(apiResponse.data);
      })
      .catch(err => {
        console.error("Failed to fetch infrastructure update date:", err);
      })
      .finally(() => {
        setIsLoading(false); // Done loading, whether it succeeded or failed
      });
  }, []); // Empty dependency array means this runs once on mount

  return (
    <Card variant="outlined" sx={{ width: '100%', height: 600 }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          Infrastructure risk map
          {updateDate && ` (last updated ${updateDate})`}
        </Typography>
        <Box sx={{ height: 550, position: 'relative' }}>
          {isLoading ? (
            // Show a spinner while the data is loading
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <CircularProgress />
            </Box>
          ) : (
            // 3. Once loaded, render the MapView and PASS the floodData to it
            <MapView floodData={floodData} />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}